import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input } from '../../../../../components/Basic/Inputs';
import Stepper from './Stepper';
import styles from './styles.module.scss';

const WarehouseStepperInput = ({ item = {}, order = {}, entryItem = {}, save = () => { }, ...props }) => {
  const skladName = useSelector((store) => store.ui.skladName.short_name);
  const [data, setData] = useState({});

  useEffect(() => {
    setData(item);
  }, [item]);

  return (
    <>
      <Row>
        <Input
          value={entryItem.entry_id ? entryItem.product.quantity : ''}
          fontSize="14px"
          textAlign="center"
          width={'35px'}
          readOnly
          styles={styles.bold_input}
          style={{ marginRight: '15px', fontWeight: 600 }}
        />

        <Stepper
          item={item}
          order={order}
          save={(v) => {
            setData(v);
            save(v);

            console.log("2", v)
          }}
          skladName={skladName}
        />
      </Row>
    </>
  );
};

export default WarehouseStepperInput;
